import { Injectable } from '@angular/core';
import { EndpointService } from '../endpoints.service';
import { StorageService } from '../../@core/services/storage.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { FeedPostResponse, FeedPostImageResponse } from '../models/response.module';
import { _FEED_1, FEED_3, _FEED_3, FEED_4, FEED_6, FEED_8 } from '../models/input.module';
import { PaginationResponse } from '../models/global/response-wrapper.service';

@Injectable({
  providedIn: 'root'
})
export class FeedService {

  constructor(
    private endpointService: EndpointService,
    private storageService: StorageService
  ) {}

  // Get feed posts for current company
  getFeedPosts(params: _FEED_1 = {}): Observable<PaginationResponse<FeedPostResponse[]>> {
    const payload = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    };
    return this.endpointService.feed_1(payload);
  }

  // Get feed posts for specific company
  getFeedPostsByCompanyId(companyId: string, params: _FEED_1 = {}): Observable<PaginationResponse<FeedPostResponse[]>> {
    const payload = {
      company_id: companyId,
      ...params
    };
    return this.endpointService.feed_1(payload);
  }

  // Get single feed post
  getFeedPost(feedPostId: string): Observable<FeedPostResponse> {
    return this.endpointService.feed_2(feedPostId).pipe(
      map(response => response.data)
    );
  }

  // Create feed post
  createFeedPost(params: _FEED_3): Observable<FeedPostResponse> {
    const payload: FEED_3 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params
    };
    return this.endpointService.feed_3(payload).pipe(
      map(response => response.data)
    );
  }

  // Update feed post
  updateFeedPost(params: FEED_4): Observable<FeedPostResponse> {
    return this.endpointService.feed_4(params).pipe(
      map(response => response.data)
    );
  }

  // Delete feed post
  deleteFeedPost(feedPostId: string): Observable<any> {
    return this.endpointService.feed_5(feedPostId);
  }

  // Add image to feed post
  addImage(feedPostId: string, image: File): Observable<FeedPostImageResponse> {
    const payload: FEED_6 = {
      feed_post_id: feedPostId,
      image: image
    };
    return this.endpointService.feed_6(payload).pipe(
      map(response => response.data)
    );
  }

  // Delete image from feed post
  deleteImage(imageId: number): Observable<any> {
    return this.endpointService.feed_7(imageId);
  }

  // Reorder images in feed post
  reorderImages(feedPostId: string, imageOrder: number[]): Observable<FeedPostResponse> {
    const payload: FEED_8 = {
      feed_post_id: feedPostId,
      image_order: imageOrder
    };
    return this.endpointService.feed_8(payload).pipe(
      map(response => response.data)
    );
  }

  // Get public feed posts for a company (no auth required)
  getPublicFeedPosts(companyId: string, params: { page?: number; limit?: number } = {}): Observable<PaginationResponse<FeedPostResponse[]>> {
    return this.endpointService.feed_9(companyId, params);
  }
}
